// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// Export the factory function instead of a class to prevent initialization order problems

import type { UserOfficeAffiliation } from "le-coffre-resources/dist/Notary";

// Export a compatible interface for backwards compatibility
export interface IUserOffices {
	getUserOffices(userUid: string): Promise<UserOfficeAffiliation[]>;
	setActiveOffice(
		userUid: string,
		officeUid: string,
		menuOfficeUidForGuestJwt?: string | null,
	): Promise<{ message: string; office_uid: string; accessToken?: string; refreshToken?: string }>;
	getActiveOffice(userUid: string): Promise<UserOfficeAffiliation>;
	syncUserOffices(userUid: string): Promise<UserOfficeAffiliation[]>;
}

import { getLazyFactoryGetter } from "@Front/Api/helpers/dynamicFactoryLoader";

function getFactory(): () => IUserOffices {
	return getLazyFactoryGetter("LeCoffreApi/Notary/UserOffices") as () => IUserOffices;
}

// Export the instance getter as the main export
export const UserOfficesApi = {
	getInstance: (): IUserOffices => {
		return getFactory()();
	},
};

// Export default for backward compatibility with existing imports
export default UserOfficesApi;
